import styled, { keyframes } from 'styled-components'

interface ILoadingMessagesProps {
  style?: React.CSSProperties,
  nobackground?:boolean,
  maxWidth?: string | number
}

const spin = keyframes`
0% {
  transform: rotate(0);
}
100% {
  transform: rotate(360deg);
}
`

const spinBack = keyframes`
0% {
  transform: rotate(0);
}
100% {
  transform: rotate(360deg);
}
`

const Wheel1 = styled.path`
  animation: 1.9s Infinite  linear ${spin};
  animation-delay: 0s;
`

const Wheel2 = styled.path`
  animation: 2.3s Infinite  linear ${spinBack};
  animation-delay: 0s;
`

export const LoadingMessages: React.FC<ILoadingMessagesProps> = ({ style,nobackground = false, maxWidth=756 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
      width={maxWidth}
      height={546}
      style={style || {}}
    >
      <g
        className="animable"
        style={{
          transformOrigin: "250px 228.23px",
          opacity: nobackground?0:1
        }}
      >
        <path
          style={{
            fill: "#ebebeb",
            transformOrigin: "250px 382.525px",
          }}
          className="animable"
          d="M0 382.4h500v.25H0z"
        />
        <path
          style={{
            fill: "#ebebeb",
            transformOrigin: "148.03px 397.945px",
          }}
          className="animable"
          d="M131.47 397.82h33.12v.25h-33.12z"
        />
        <path
          style={{
            fill: "#ebebeb",
            transformOrigin: "254.495px 395.235px",
          }}
          className="animable"
          d="M250.15 395.11h8.69v.25h-8.69z"
        />
        <path
          style={{
            fill: "#ebebeb",
            transformOrigin: "62.055px 391.015px",
          }}
          className="animable"
          d="M52.46 390.89h19.19v.25H52.46z"
        />
        <path
          style={{
            fill: "#ebebeb",
            transformOrigin: "402.74px 389.335px",
          }}
          className="animable"
          d="M389.7 389.21h26.08v.25H389.7z"
        />
        <path
          style={{
            fill: "#ebebeb",
            transformOrigin: "369.07px 389.335px",
          }}
          className="animable"
          d="M357.35 389.21h23.44v.25h-23.44z"
        />
        <path
          style={{
            fill: "#ebebeb",
            transformOrigin: "403.07px 401.335px",
          }}
          className="animable"
          d="M356.23 401.21h93.68v.25h-93.68z"
        />
        <path
          d="M237 337.8H43.91a5.71 5.71 0 0 1-5.7-5.71V60.66a5.71 5.71 0 0 1 5.7-5.66H237a5.71 5.71 0 0 1 5.71 5.71v271.38a5.71 5.71 0 0 1-5.71 5.71ZM43.91 55.2a5.46 5.46 0 0 0-5.45 5.46v271.43a5.46 5.46 0 0 0 5.45 5.46H237a5.47 5.47 0 0 0 5.46-5.46V60.66A5.47 5.47 0 0 0 237 55.2Z"
          style={{
            fill: "#ebebeb",
            transformOrigin: "140.46px 196.4px",
          }}
          className="animable"
        />
        <path
          d="M453.31 337.8h-193.1a5.72 5.72 0 0 1-5.71-5.71V60.66a5.72 5.72 0 0 1 5.71-5.66h193.1a5.71 5.71 0 0 1 5.69 5.66v271.43a5.71 5.71 0 0 1-5.69 5.71ZM260.21 55.2a5.47 5.47 0 0 0-5.46 5.46v271.43a5.47 5.47 0 0 0 5.46 5.46h193.1a5.47 5.47 0 0 0 5.46-5.46V60.66a5.47 5.47 0 0 0-5.46-5.46Z"
          style={{
            fill: "#ebebeb",
            transformOrigin: "356.75px 196.4px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "330.385px 327.9px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M318.61 276.38h23.55v103.04h-23.55z"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "285.785px 380.91px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M233.94 379.42h103.69v2.98H233.94z"
        />
        <path
          style={{
            fill: "#f5f5f5",
            transformOrigin: "274.01px 327.9px",
          }}
          className="animable"
          d="M229.42 276.38h89.18v103.04h-89.18z"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "274.01px 303.88px",
          }}
          className="animable"
          d="M238.68 282.16h70.66v43.44h-70.66z"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "274.01px 351.92px",
          }}
          className="animable"
          d="M238.68 330.2h70.66v43.44h-70.66z"
        />
        <path
          d="M292.33 289.73H255.7A8.69 8.69 0 0 1 247 281h54a8.69 8.69 0 0 1-8.67 8.73Z"
          style={{
            fill: "#f5f5f5",
            transformOrigin: "274px 285.365px",
          }}
          className="animable"
        />
        <path
          d="M292.33 337.77H255.7a8.69 8.69 0 0 1-8.69-8.69h54a8.69 8.69 0 0 1-8.68 8.69Z"
          style={{
            fill: "#f5f5f5",
            transformOrigin: "274.01px 333.425px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "426.555px 327.9px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M414.78 276.38h23.55v103.04h-23.55z"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "381.965px 380.91px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M330.12 379.42h103.69v2.98H330.12z"
        />
        <path
          style={{
            fill: "#f5f5f5",
            transformOrigin: "370.19px 327.9px",
          }}
          className="animable"
          d="M325.6 276.38h89.18v103.04H325.6z"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "370.19px 303.88px",
          }}
          className="animable"
          d="M334.86 282.16h70.66v43.44h-70.66z"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "370.19px 351.92px",
          }}
          className="animable"
          d="M334.86 330.2h70.66v43.44h-70.66z"
        />
        <path
          d="M388.5 289.73h-36.63a8.69 8.69 0 0 1-8.69-8.69h54a8.69 8.69 0 0 1-8.68 8.69Z"
          style={{
            fill: "#f5f5f5",
            transformOrigin: "370.18px 285.385px",
          }}
          className="animable"
        />
        <path
          d="M388.5 337.77h-36.63a8.69 8.69 0 0 1-8.69-8.69h54a8.69 8.69 0 0 1-8.68 8.69Z"
          style={{
            fill: "#f5f5f5",
            transformOrigin: "370.18px 333.425px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#e6e6e6",
            transformOrigin: "131.59px 114.635px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M111.42 91.32h40.34v46.63h-40.34z"
        />
        <path
          style={{
            fill: "#f5f5f5",
            transformOrigin: "128.75px 114.635px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M106.82 91.32h43.86v46.63h-43.86z"
        />
        <path
          style={{
            fill: "#fff",
            transformOrigin: "128.75px 114.635px",
            transform: "rotate(90deg)",
          }}
          className="animable"
          d="M109.11 96.38h39.28v36.51h-39.28z"
        />
        <path
          d="M138.16 124.75v-1.43a18.82 18.82 0 0 0-18.81-18.81v1.43a18.81 18.81 0 0 0 18.81 18.81Z"
          style={{
            fill: "#f5f5f5",
            transformOrigin: "128.755px 114.63px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#e6e6e6",
            transformOrigin: "362.48px 155.01px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M286.63 84.06h151.7v141.9h-151.7z"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "359.03px 155.01px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M281.93 84.06h154.2v141.9h-154.2z"
        />
        <path
          style={{
            fill: "#e6e6e6",
            transformOrigin: "362.48px 228.48px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M286.63 225.95h151.7v5.06h-151.7z"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "351.2px 228.48px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M274.1 225.95h154.2v5.06H274.1z"
        />
        <path
          style={{
            fill: "#fafafa",
            transformOrigin: "359.03px 155.01px",
            transform: "rotate(90deg)",
          }}
          className="animable"
          d="M295.7 84.49h126.66v141.04H295.7z"
        />
        <path
          style={{
            fill: "#fff",
            transformOrigin: "358.465px 155.005px",
          }}
          className="animable"
          d="M389.56 218.34 366.07 91.67h-38.7l23.49 126.67h38.7z"
        />
        <path
          d="M426.51 175.36a.51.51 0 0 0 .47-.54V96.63a.47.47 0 1 0-.94 0v78.19a.51.51 0 0 0 .47.54Z"
          style={{
            fill: "#f0f0f0",
            transformOrigin: "426.51px 135.76px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#fff",
            transformOrigin: "323.255px 155.005px",
          }}
          className="animable"
          d="M342.54 218.34 319.06 91.67h-15.09l23.48 126.67h15.09z"
        />
        <path
          style={{
            fill: "#e6e6e6",
            transformOrigin: "288.93px 155.01px",
            transform: "rotate(90deg)",
          }}
          className="animable"
          d="M225.6 154.59h126.66v.84H225.6z"
        />
        <path
          style={{
            fill: "#e6e6e6",
            opacity: 0.4,
            transformOrigin: "356.53px 98.03px",
          }}
          className="animable"
          d="M280.38 101.42h151.69l.61-6.78h-151.7l-.6 6.78z"
        />
        <path
          style={{
            fill: "#e6e6e6",
            opacity: 0.4,
            transformOrigin: "356.53px 105.835px",
          }}
          className="animable"
          d="M280.38 109.23h151.69l.61-6.79h-151.7l-.6 6.79z"
        />
        <path
          style={{
            fill: "#e6e6e6",
            opacity: 0.4,
            transformOrigin: "356.53px 113.64px",
          }}
          className="animable"
          d="M280.38 117.03h151.69l.61-6.78h-151.7l-.6 6.78z"
        />
        <path
          style={{
            fill: "#e6e6e6",
            opacity: 0.4,
            transformOrigin: "356.53px 121.445px",
          }}
          className="animable"
          d="M280.38 124.84h151.69l.61-6.79h-151.7l-.6 6.79z"
        />
        <path
          style={{
            fill: "#e6e6e6",
            opacity: 0.4,
            transformOrigin: "356.53px 129.25px",
          }}
          className="animable"
          d="M280.38 132.64h151.69l.61-6.78h-151.7l-.6 6.78z"
        />
        <path
          style={{
            fill: "#e6e6e6",
            opacity: 0.4,
            transformOrigin: "356.53px 137.055px",
          }}
          className="animable"
          d="M280.38 140.45h151.69l.61-6.79h-151.7l-.6 6.79z"
        />
        <path
          style={{
            fill: "#e6e6e6",
            opacity: 0.4,
            transformOrigin: "356.53px 144.86px",
          }}
          className="animable"
          d="M280.38 148.25h151.69l.61-6.78h-151.7l-.6 6.78z"
        />
        <path
          style={{
            fill: "#e6e6e6",
            opacity: 0.4,
            transformOrigin: "356.53px 152.665px",
          }}
          className="animable"
          d="M280.38 156.06h151.69l.61-6.79h-151.7l-.6 6.79z"
        />
        <path
          style={{
            fill: "#e6e6e6",
            opacity: 0.4,
            transformOrigin: "356.53px 160.47px",
          }}
          className="animable"
          d="M280.38 163.86h151.69l.61-6.78h-151.7l-.6 6.78z"
        />
        <path
          style={{
            fill: "#e6e6e6",
            transformOrigin: "98.555px 195.955px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M82.82 177.9h31.47v36.11H82.82z"
        />
        <path
          style={{
            fill: "#f5f5f5",
            transformOrigin: "96.245px 195.955px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M79.26 177.9h33.97v36.11H79.26z"
        />
        <path
          style={{
            fill: "#fff",
            transformOrigin: "96.24px 195.95px",
            transform: "rotate(90deg)",
          }}
          className="animable"
          d="M81.03 181.81h30.42v28.28H81.03z"
        />
        <path
          d="M103.53 196.51v-1.11a7.28 7.28 0 0 0-7.29-7.28A7.28 7.28 0 0 0 89 195.4v1.11a7.28 7.28 0 0 0 7.28 7.28 7.28 7.28 0 0 0 7.25-7.28Z"
          style={{
            fill: "#f5f5f5",
            transformOrigin: "96.265px 195.955px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#e6e6e6",
            transformOrigin: "182.925px 176.19px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M161.32 151.3h43.21v49.78h-43.21z"
        />
        <path
          style={{
            fill: "#f5f5f5",
            transformOrigin: "179.82px 176.19px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M156.41 151.3h46.82v49.78h-46.82z"
        />
        <path
          style={{
            fill: "#fff",
            transformOrigin: "179.825px 176.19px",
            transform: "rotate(90deg)",
          }}
          className="animable"
          d="M158.86 156.7h41.93v38.98h-41.93z"
        />
        <path
          d="m181.45 168.41 7.4 12.82a1.88 1.88 0 0 1-1.63 2.82h-14.8a1.88 1.88 0 0 1-1.63-2.82l7.4-12.82a1.89 1.89 0 0 1 3.26 0Z"
          style={{
            fill: "#f5f5f5",
            transformOrigin: "179.82px 175.763px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#e6e6e6",
            transformOrigin: "101.895px 344.96px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M90.02 307.52h23.75v74.88H90.02z"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "94.64px 375.985px",
          }}
          className="animable"
          d="M94.53 382.4h-4.51v-12.83h9.24l-4.73 12.83z"
        />
        <path
          style={{
            fill: "#e6e6e6",
            transformOrigin: "190.645px 344.96px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M178.77 307.52h23.75v74.88h-23.75z"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "136.36px 341.025px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M90.02 307.52h92.68v67.01H90.02z"
        />
        <path
          style={{
            fill: "#e6e6e6",
            transformOrigin: "114.185px 335.105px",
            transform: "rotate(-90deg)",
          }}
          className="animable"
          d="M90.8 314.44h46.77v41.33H90.8z"
        />
        <path
          style={{
            fill: "#e6e6e6",
            transformOrigin: "158.545px 335.105px",
            transform: "rotate(-90deg)",
          }}
          className="animable"
          d="M135.16 314.44h46.77v41.33h-46.77z"
        />
        <path
          d="M154.46 315.31h8.17a12.93 12.93 0 0 0 9.39-4h-27a12.91 12.91 0 0 0 9.44 4Z"
          style={{
            fill: "#f0f0f0",
            transformOrigin: "158.52px 313.31px",
          }}
          className="animable"
        />
        <path
          d="M109.68 315.31h8.18a12.94 12.94 0 0 0 9.39-4h-27a12.93 12.93 0 0 0 9.43 4Z"
          style={{
            fill: "#f0f0f0",
            transformOrigin: "113.75px 313.31px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#f0f0f0",
            transformOrigin: "178.09px 375.985px",
          }}
          className="animable"
          d="M178.2 382.4h4.51v-12.83h-9.24l4.73 12.83z"
        />
        <path
          d="M153.75 297.48a5.15 5.15 0 1 0 5.15-5.14 5.16 5.16 0 0 0-5.15 5.14Z"
          style={{
            fill: "#e0e0e0",
            transformOrigin: "158.9px 297.49px",
          }}
          className="animable"
        />
        <circle
          cx={161.23}
          cy={294.14}
          r={5.14}
          style={{
            fill: "#e0e0e0",
            transformOrigin: "161.23px 294.14px",
          }}
          className="animable"
        />
        <path
          d="M128 298.31a5.14 5.14 0 1 0 5.14-5.14 5.14 5.14 0 0 0-5.14 5.14Z"
          style={{
            fill: "#e0e0e0",
            transformOrigin: "133.14px 298.31px",
          }}
          className="animable"
        />
        <circle
          cx={168.11}
          cy={294.98}
          r={6.31}
          style={{
            fill: "#e0e0e0",
            transformOrigin: "168.11px 294.98px",
          }}
          className="animable"
        />
        <path
          d="M149.3 289.17a6.31 6.31 0 1 0 6.31-6.3 6.32 6.32 0 0 0-6.31 6.3Z"
          style={{
            fill: "#e0e0e0",
            transformOrigin: "155.61px 289.18px",
          }}
          className="animable"
        />
        <path
          d="M139.3 290.78a6.31 6.31 0 1 0 6.31-6.3 6.31 6.31 0 0 0-6.31 6.3Z"
          style={{
            fill: "#e0e0e0",
            transformOrigin: "145.61px 290.79px",
          }}
          className="animable"
        />
        <path
          d="M143.53 295.87a6 6 0 1 0 6-6 6 6 0 0 0-6 6Z"
          style={{
            fill: "#e0e0e0",
            transformOrigin: "149.53px 295.87px",
          }}
          className="animable"
        />
        <path
          d="M133.09 295.48a6.48 6.48 0 1 0 6.48-6.48 6.48 6.48 0 0 0-6.48 6.48Z"
          style={{
            fill: "#e0e0e0",
            transformOrigin: "139.57px 295.48px",
          }}
          className="animable"
        />
        <path
          d="M178.17 297.48s-.7 10-27.77 10-27.78-10-27.78-10Z"
          style={{
            fill: "#f0f0f0",
            transformOrigin: "150.395px 302.48px",
          }}
          className="animable"
        />
      </g>
      <g
        className="animable"
        style={{
          transformOrigin: "250px 416.24px",
          opacity: nobackground?0:1
        }}
      >
        <ellipse
          cx={250}
          cy={416.24}
          rx={193.89}
          ry={11.32}
          style={{
            fill: "#f5f5f5",
            transformOrigin: "250px 416.24px",
          }}
          className="animable"
        />
      </g>
      <g
        className="animable"
        style={{
          transformOrigin: "333.355px 160.795px",
        }}
      >
        <Wheel2
          d="M307.77 119.9a42.3 42.3 0 0 0-3.22-7.76l2-6.55-12.93-12.94-6.55 2a42.3 42.3 0 0 0-7.76-3.22l-3.22-6h-18.3l-3.21 6a42 42 0 0 0-7.76 3.22l-6.55-2-12.94 12.94 2 6.55a43 43 0 0 0-3.21 7.76l-6.05 3.22v18.3l6.05 3.21a42.67 42.67 0 0 0 3.21 7.76l-2 6.55 12.94 12.94 6.55-2a42.67 42.67 0 0 0 7.76 3.21l3.21 6h18.3l3.22-6a43 43 0 0 0 7.76-3.21l6.55 2 12.94-12.94-2-6.55a42 42 0 0 0 3.22-7.76l6.05-3.21v-18.3Zm-40.83 38.36a26 26 0 1 1 26-26 26 26 0 0 1-26 26Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "266.95px 132.26px",
          }}
          className="animable"
        />
        <Wheel2
          d="M307.77 119.9a42.3 42.3 0 0 0-3.22-7.76l2-6.55-12.93-12.94-6.55 2a42.3 42.3 0 0 0-7.76-3.22l-3.22-6h-18.3l-3.21 6a42 42 0 0 0-7.76 3.22l-6.55-2-12.94 12.94 2 6.55a43 43 0 0 0-3.21 7.76l-6.05 3.22v18.3l6.05 3.21a42.67 42.67 0 0 0 3.21 7.76l-2 6.55 12.94 12.94 6.55-2a42.67 42.67 0 0 0 7.76 3.21l3.21 6h18.3l3.22-6a43 43 0 0 0 7.76-3.21l6.55 2 12.94-12.94-2-6.55a42 42 0 0 0 3.22-7.76l6.05-3.21v-18.3Zm-40.83 38.36a26 26 0 1 1 26-26 26 26 0 0 1-26 26Z"
          style={{
            fill: "#fff",
            opacity: 0.2,
            transformOrigin: "266.95px 132.26px",
          }}
          className="animable"
        />
        <path
          d="M266.94 123.65a8.62 8.62 0 1 0 8.62 8.62 8.62 8.62 0 0 0-8.62-8.62Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "266.94px 132.27px",
          }}
          className="animable"
        />
        <Wheel1
          d="M438 148.93a61.16 61.16 0 0 0-4.59-11.1l2.86-9.36L417.8 110l-9.37 2.87a58.11 58.11 0 0 0-11.09-4.6l-4.59-8.64H366.6l-4.6 8.64a58.65 58.65 0 0 0-11.09 4.6l-9.36-2.87-18.49 18.49 2.86 9.36a59.76 59.76 0 0 0-4.59 11.1l-8.65 4.59v26.15l8.64 4.6a59.39 59.39 0 0 0 4.59 11.09l-2.86 9.35 18.49 18.49 9.36-2.86a58.61 58.61 0 0 0 11.1 4.58l4.6 8.65h26.15l4.59-8.64a59.42 59.42 0 0 0 11.09-4.6l9.37 2.86 18.49-18.49-2.86-9.36a60.77 60.77 0 0 0 4.57-11.09l8.64-4.6v-26.15ZM379.67 214a47.41 47.41 0 1 1 47.41-47.41A47.41 47.41 0 0 1 379.67 214Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "379.66px 166.61px",
          }}
          className="animable"
        />
        <path
          d="M379.67 125.83a40.77 40.77 0 1 0 40.78 40.77 40.82 40.82 0 0 0-40.78-40.77Zm0 76.11A35.34 35.34 0 1 1 415 166.6a35.38 35.38 0 0 1-35.33 35.34Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "379.68px 166.6px",
          }}
          className="animable"
        />
        <path
          d="M379.67 125.83a40.77 40.77 0 1 0 40.78 40.77 40.82 40.82 0 0 0-40.78-40.77Zm0 76.11A35.34 35.34 0 1 1 415 166.6a35.38 35.38 0 0 1-35.33 35.34Z"
          style={{
            opacity: 0.2,
            transformOrigin: "379.68px 166.6px",
          }}
          className="animable"
        />
        <path
          d="M286 236.16a1 1 0 0 1-1-1v-2a1 1 0 1 1 2 0v2a1 1 0 0 1-1 1Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "286px 234.16px",
          }}
          className="animable"
        />
        <path
          d="M270.43 210.32a5.41 5.41 0 0 1-2.06-2.45 1 1 0 0 0-1.84.79 7.55 7.55 0 0 0 2.81 3.34 1 1 0 0 0 .54.16 1 1 0 0 0 .55-1.84Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "268.668px 209.712px",
          }}
          className="animable"
        />
        <path
          d="M266.94 197.83a1 1 0 0 0 1-1V193a1 1 0 0 0-2 0v3.83a1 1 0 0 0 1 1Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "266.94px 194.915px",
          }}
          className="animable"
        />
        <path
          d="M277.35 211.2h-3.84a1 1 0 0 0 0 2h3.84a1 1 0 0 0 0-2Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "275.43px 212.2px",
          }}
          className="animable"
        />
        <path
          d="M267.94 204.5v-3.83a1 1 0 0 0-2 0v3.83a1 1 0 0 0 2 0Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "266.94px 202.585px",
          }}
          className="animable"
        />
        <path
          d="M286.94 217.7a1 1 0 0 0-1.12-.86A1 1 0 0 0 285 218a5.36 5.36 0 0 1 .05.7v3a1 1 0 0 0 2 0v-3a7.73 7.73 0 0 0-.11-1Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "286.017px 219.766px",
          }}
          className="animable"
        />
        <path
          d="M286 224.49a1 1 0 0 0-1 1v3.84a1 1 0 1 0 2 0v-3.84a1 1 0 0 0-1-1Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "286px 227.41px",
          }}
          className="animable"
        />
        <path
          d="M285.13 213.73a7.41 7.41 0 0 0-3.71-2.29 1 1 0 0 0-.5 1.94 5.39 5.39 0 0 1 2.71 1.67 1 1 0 0 0 .75.34 1 1 0 0 0 .75-1.66Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "282.774px 213.399px",
          }}
          className="animable"
        />
        <path
          d="M266.94 190.12a1 1 0 0 1-1-1v-2a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "266.94px 188.12px",
          }}
          className="animable"
        />
      </g>
      <g
        className="animable"
        style={{
          transformOrigin: "242.72px 327.06px",
        }}
      >
        <path
          style={{
            fill: "#4e658a",
            transformOrigin: "217.6px 288.365px",
          }}
          className="animable"
          d="M101.83 286.51h231.54v3.71H101.83z"
        />
        <path
          style={{
            fill: "#4e658a",
            transformOrigin: "358.49px 288.365px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M333.37 286.51h50.24v3.71h-50.24z"
        />
        <path
          style={{
            opacity: 0.2,
            transformOrigin: "358.49px 288.365px",
            transform: "rotate(180deg)",
          }}
          className="animable"
          d="M333.37 286.51h50.24v3.71h-50.24z"
        />
        <path
          style={{
            fill: "#4e658a",
            transformOrigin: "242.72px 292.205px",
          }}
          className="animable"
          d="M366.83 294.19H118.61l-8.3-3.97h264.82l-8.3 3.97z"
        />
        <path
          style={{
            fill: "#fff",
            opacity: 0.6,
            transformOrigin: "242.72px 292.205px",
          }}
          className="animable"
          d="M366.83 294.19H118.61l-8.3-3.97h264.82l-8.3 3.97z"
        />
        <path
          style={{
            fill: "#4e658a",
            transformOrigin: "129.7px 353.36px",
          }}
          className="animable"
          d="M126.11 294.19v118.34h3.18l4-118.34h-7.18z"
        />
        <path
          style={{
            fill: "#4e658a",
            transformOrigin: "167.24px 353.36px",
          }}
          className="animable"
          d="M163.65 294.19v118.34h3.18l4-118.34h-7.18z"
        />
        <path
          style={{
            fill: "#4e658a",
            transformOrigin: "363.24px 353.36px",
          }}
          className="animable"
          d="M366.83 294.19v118.34h-3.17l-4.01-118.34h7.18z"
        />
        <path
          style={{
            fill: "#4e658a",
            transformOrigin: "325.71px 353.36px",
          }}
          className="animable"
          d="M329.3 294.19v118.34h-3.18l-4-118.34h7.18z"
        />
        <path
          style={{
            fill: "#4e658a",
            transformOrigin: "284.41px 264.05px",
          }}
          className="animable"
          d="m253.74 241.59-10.45 42.57-.29 2.35h72.08l.3-2.35 10.44-42.57h-72.08z"
        />
        <path
          style={{
            opacity: 0.3,
            transformOrigin: "284.41px 264.05px",
          }}
          className="animable"
          d="m253.74 241.59-10.45 42.57-.29 2.35h72.08l.3-2.35 10.44-42.57h-72.08z"
        />
        <path
          style={{
            fill: "#4e658a",
            transformOrigin: "282.345px 262.875px",
          }}
          className="animable"
          d="M323.61 241.59h-72.09l-10.44 42.57h72.08l10.45-42.57z"
        />
        <path
          style={{
            fill: "#fff",
            transformOrigin: "282.345px 262.875px",
          }}
          className="animable"
          d="m311.63 282.21 9.5-38.67h-68.08l-9.49 38.67h68.07z"
        />
        <path
          style={{
            fill: "#4e658a",
            transformOrigin: "254.545px 285.335px",
          }}
          className="animable"
          d="m294.38 284.16-.3 2.35h-79.37l.29-2.35h79.38z"
        />
        <path
          style={{
            fill: "#fff",
            opacity: 0.6,
            transformOrigin: "254.545px 285.335px",
          }}
          className="animable"
          d="m294.38 284.16-.3 2.35h-79.37l.29-2.35h79.38z"
        />
        <path
          d="M144.44 278.77a6.35 6.35 0 0 0-5.63-6.1v-1.15a.5.5 0 0 0-.52-.49h-10.8a.51.51 0 0 0-.53.49v15h11.85v-1.64a6.34 6.34 0 0 0 5.63-6.11Zm-5.63 4.17v-8.33a4.21 4.21 0 0 1 0 8.33Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "135.7px 278.775px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#263238",
            transformOrigin: "351.58px 275.515px",
          }}
          className="animable"
          d="M346.56 286.51h10.04l-2.97-21.99h-7.07v21.99z"
        />
        <path
          style={{
            fill: "#4e658a",
            transformOrigin: "343.115px 273.64px",
          }}
          className="animable"
          d="M331.84 286.51h19.02l3.53-25.74h-19.01l-3.54 25.74z"
        />
        <path
          style={{
            opacity: 0.3,
            transformOrigin: "343.115px 273.64px",
          }}
          className="animable"
          d="M331.84 286.51h19.02l3.53-25.74h-19.01l-3.54 25.74z"
        />
        <path
          style={{
            fill: "#4e658a",
            transformOrigin: "340.965px 273.64px",
          }}
          className="animable"
          d="M329.3 286.51h19.79l3.54-25.74h-19.79l-3.54 25.74z"
        />
        <path
          style={{
            fill: "#fff",
            opacity: 0.4,
            transformOrigin: "340.965px 273.64px",
          }}
          className="animable"
          d="m347.34 284.48 2.98-21.68h-15.73l-2.98 21.68h15.73z"
        />
      </g>
      <g
        className="animable"
        style={{
          transformOrigin: "236.378px 300.348px",
        }}
      >
        <path
          d="m197.54 248.51-.82.88-.88 1c-.59.68-1.18 1.37-1.74 2.08a75.14 75.14 0 0 0-3.21 4.36 46.61 46.61 0 0 0-5 9.24 28.59 28.59 0 0 0-1.42 4.78c-.16.92-.26 1.32-.31 1.71a2.68 2.68 0 0 0 0 .94 3.9 3.9 0 0 0 2 2.25 14 14 0 0 0 2.12 1.07q.58.24 1.2.45c.38.14.86.28 1.16.4v5.51c-.7.1-1.21.18-1.8.22s-1.16.05-1.75 0a17 17 0 0 1-3.6-.46 13.49 13.49 0 0 1-3.78-1.52 10.94 10.94 0 0 1-3.48-3.23 11.67 11.67 0 0 1-1.82-4.66 9.89 9.89 0 0 1-.13-1.18 10.94 10.94 0 0 1 0-1.14v-.56a3 3 0 0 1 0-.45l.08-.88a34.7 34.7 0 0 1 1.44-6.73 49.94 49.94 0 0 1 5.67-11.92 57.63 57.63 0 0 1 3.77-5.25c.67-.84 1.36-1.66 2.08-2.47a36.643 36.643 0 0 1 2.35-2.46Z"
          style={{
            fill: "#b55b52",
            transformOrigin: "185.903px 261.962px",
          }}
          className="animable"
        />
        <path
          d="m188.65 277.55 4.66-3.42 2.65 9.58s-4.13 1.53-7.28-.53Z"
          style={{
            fill: "#b55b52",
            transformOrigin: "192.305px 279.193px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#b55b52",
            transformOrigin: "197.455px 277.77px",
          }}
          className="animable"
          d="m199.78 271.83 1.82 8.02-5.64 3.86-2.65-9.58 6.47-2.3z"
        />
        <path
          d="M229.25 211.75c-.21.59-.06 1.18.33 1.31s.87-.23 1.07-.82.06-1.19-.32-1.32-.87.23-1.08.83Z"
          style={{
            fill: "#263238",
            transformOrigin: "229.948px 211.99px",
          }}
          className="animable"
        />
        <path
          d="M229.14 212.91a22.54 22.54 0 0 0 1.07 6.06 3.63 3.63 0 0 1-3-.46Z"
          style={{
            fill: "#a02724",
            transformOrigin: "228.71px 216.01px",
          }}
          className="animable"
        />
        <path
          d="M228.29 207.73a.36.36 0 0 0 .23 0 2.92 2.92 0 0 1 2.63.4.37.37 0 0 0 .48-.56 3.67 3.67 0 0 0-3.32-.55.37.37 0 0 0 0 .7Z"
          style={{
            fill: "#263238",
            transformOrigin: "229.899px 207.522px",
          }}
          className="animable"
        />
        <path
          d="M207.32 213.93c1.12 5.69 2.23 16.12-1.75 19.92 0 0 1.56 5.77 12.14 5.77 11.63 0 5.56-5.77 5.56-5.77-6.35-1.52-6.19-6.23-5.08-10.65Z"
          style={{
            fill: "#b55b52",
            transformOrigin: "215.212px 226.775px",
          }}
          className="animable"
        />
        <path
          d="M204.05 235.83c-.84-1.83-1.75-3.92.14-4.57 2.09-.72 13.53-1.46 17.47-.11a4.06 4.06 0 0 1 2.83 5.06Z"
          style={{
            fill: "#263238",
            transformOrigin: "213.865px 233.304px",
          }}
          className="animable"
        />
        <path
          d="M244 245.59c2.45 4.41 5.08 8.95 7.74 13.31s5.45 8.7 8.43 12.66c.74 1 1.51 1.95 2.27 2.9.38.49.78.89 1.17 1.34l.58.66.15.17.07.08.07.09a4.38 4.38 0 0 0 1.64 1 15.7 15.7 0 0 0 2.91.71 65.22 65.22 0 0 0 14.61-.17l1.52 5.3c-1.35.6-2.61 1-3.95 1.5s-2.66.83-4 1.17a38.86 38.86 0 0 1-8.68 1.16 21.23 21.23 0 0 1-4.89-.49 13.49 13.49 0 0 1-5.44-2.42l-.67-.55-.16-.14-.1-.1-.19-.19-.78-.77c-.51-.51-1.07-1-1.53-1.54-1-1.05-1.94-2.1-2.81-3.18a129.93 129.93 0 0 1-9.65-13.29q-2.19-3.42-4.22-6.91c-1.36-2.35-2.67-4.65-3.94-7.13Z"
          style={{
            fill: "#b55b52",
            transformOrigin: "259.655px 266.531px",
          }}
          className="animable"
        />
        <path
          d="M191.64 235.61c-7.3 1.67-15.66 21.56-15.66 21.56l14.65 10a123.23 123.23 0 0 0 9.67-16.45c4.33-9.06-1.2-16.82-8.66-15.11Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "188.902px 251.271px",
          }}
          className="animable"
        />
        <path
          d="m196.86 248.29-6.92 18.44.68.48s3-4.21 6.24-9.89Z"
          style={{
            opacity: 0.2,
            transformOrigin: "193.4px 257.75px",
          }}
          className="animable"
        />
        <path
          d="M235.24 236s8.28 9.36.46 67.26h-41.63c-.28-6.39 3.73-37.55-2.43-67.66a108.85 108.85 0 0 1 13.93-1.76 151.37 151.37 0 0 1 17.7 0 77.87 77.87 0 0 1 11.97 2.16Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "215.35px 268.421px",
          }}
          className="animable"
        />
        <path
          d="M230.61 252.75a37 37 0 0 0 8.22 17.82c.17-3.73.24-7.08.23-10.07Z"
          style={{
            opacity: 0.2,
            transformOrigin: "234.835px 261.66px",
          }}
          className="animable"
        />
        <path
          d="M227 242.32c-1 7.37 13.5 26.19 13.5 26.19l14.59-10s-4.05-10.37-10.86-17.17c-7.76-7.8-16.09-7.04-17.23.98Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "241.02px 252.195px",
          }}
          className="animable"
        />
        <path
          d="m282 278.39 5.94-2.44 6.11 4.62s-5.83 5.16-11.13 3.15Z"
          style={{
            fill: "#b55b52",
            transformOrigin: "288.025px 280.067px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#b55b52",
            transformOrigin: "292.125px 278.14px",
          }}
          className="animable"
          d="m291.86 275.71 4.48 3.2-2.32 1.66-6.11-4.62 3.95-.24z"
        />
        <path
          d="M209.91 203.61c-2.08 7.44-3.68 11.69-1.3 16.7 3.57 7.55 13.72 7.34 18 .68 3.84-6 6.6-17.16.48-22.53a10.54 10.54 0 0 0-17.18 5.15Z"
          style={{
            fill: "#b55b52",
            transformOrigin: "219.052px 210.89px",
          }}
          className="animable"
        />
        <path
          d="M225.75 203.69c-3 8.54-6.53 17.92-15.15 16.14-5.56-1.15-6-10.1-8-14.17-1.77-3.57-1.66-10.75 2-10.84-1.64-2.38 6.65-11.09 12.31-6.49 1.45-2 11.9-7.89 19.64 1.46 7.29 8.84 3.72 16.21-10.8 13.9Z"
          style={{
            fill: "#263238",
            transformOrigin: "220.851px 202.353px",
          }}
          className="animable"
        />
        <path
          d="M219 209.15a8.8 8.8 0 0 0 1.22 5.47c1.33 2.14 3.28 1.32 4-.87.64-2 .71-5.45-1.14-6.84s-3.8-.06-4.08 2.24Z"
          style={{
            fill: "#b55b52",
            transformOrigin: "221.79px 211.106px",
          }}
          className="animable"
        />
        <path
          d="M282.88 406.88c1 0 2-.14 2.29-.59a.71.71 0 0 0 0-.81 1 1 0 0 0-.58-.43c-1.3-.35-4 1.2-4.13 1.27a.17.17 0 0 0-.09.19.19.19 0 0 0 .14.15 13.6 13.6 0 0 0 2.37.22Zm1.24-1.51a1.25 1.25 0 0 1 .35 0 .52.52 0 0 1 .36.26c.13.23.09.34 0 .4-.36.51-2.33.52-3.78.31a8.35 8.35 0 0 1 3.07-.97Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "282.831px 405.939px",
          }}
          className="animable"
        />
        <path
          d="M280.53 406.66h.08c.94-.42 2.8-2.1 2.65-3 0-.21-.18-.46-.68-.52a1.36 1.36 0 0 0-1 .32c-1 .81-1.2 2.91-1.21 3a.19.19 0 0 0 .07.17.23.23 0 0 0 .09.03Zm1.9-3.15h.11c.33 0 .35.17.36.21.09.53-1.18 1.85-2.14 2.42a4.3 4.3 0 0 1 1-2.39 1 1 0 0 1 .67-.24Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "281.819px 404.897px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#b55b52",
            transformOrigin: "276.255px 397.465px",
          }}
          className="animable"
          d="M271.48 406.48h7.78l1.77-18.03h-7.78l-1.77 18.03z"
        />
        <path
          d="M279.7 405.58h-8.49a.69.69 0 0 0-.67.54L269 413a1.13 1.13 0 0 0 1.12 1.39c3.06-.05 7.49-.23 11.34-.23 4.51 0 8.4.24 13.68.24 3.2 0 4.09-3.23 2.75-3.52-6.09-1.33-11.06-1.47-16.32-4.72a3.61 3.61 0 0 0-1.87-.58Z"
          style={{
            fill: "#263238",
            transformOrigin: "283.731px 409.99px",
          }}
          className="animable"
        />
        <path
          style={{
            opacity: 0.2,
            transformOrigin: "276.675px 393.105px",
          }}
          className="animable"
          d="m281.02 388.46-.9 9.29h-7.79l.91-9.29h7.78z"
        />
        <path
          d="M251.69 406.87a2.51 2.51 0 0 0 1.87-.51.74.74 0 0 0 0-.87.85.85 0 0 0-.58-.43c-1.14-.27-3.29 1.2-3.38 1.26a.21.21 0 0 0-.08.19.18.18 0 0 0 .14.14 9.58 9.58 0 0 0 2.03.22Zm1-1.48a.78.78 0 0 1 .22 0 .46.46 0 0 1 .34.24c.17.31.07.43 0 .48-.33.43-1.92.44-3.09.25a6 6 0 0 1 2.51-.97Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "251.61px 405.959px",
          }}
          className="animable"
        />
        <path
          d="M249.71 406.66h.08c.81-.44 2.37-2.14 2.2-3a.6.6 0 0 0-.59-.49 1 1 0 0 0-.78.24c-.9.74-1.09 3-1.1 3.08a.2.2 0 0 0 .09.17.17.17 0 0 0 .1 0Zm1.57-3.15h.08c.24 0 .26.14.27.19.1.51-.9 1.8-1.7 2.41a4.41 4.41 0 0 1 .92-2.44.66.66 0 0 1 .43-.16Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "250.761px 404.915px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#b55b52",
            transformOrigin: "246.635px 397.465px",
          }}
          className="animable"
          d="M240.79 406.48h7.78l3.91-18.03h-7.78l-3.91 18.03z"
        />
        <path
          d="M249.12 405.58h-8.74a.68.68 0 0 0-.66.54l-1.54 6.88a1.15 1.15 0 0 0 1.14 1.39c3.05-.05 4.54-.23 8.38-.23 2.37 0 5.4.24 8.67.24s3.69-3.23 2.35-3.52c-6-1.31-6.41-3.12-8.33-4.85a1.9 1.9 0 0 0-1.27-.45Z"
          style={{
            fill: "#263238",
            transformOrigin: "248.794px 409.99px",
          }}
          className="animable"
        />
        <g
          style={{
            opacity: 0.2,
            transformOrigin: "247.58px 393.105px",
          }}
          className="animable"
        >
          <path
            className="animable"
            style={{
              transformOrigin: "247.58px 393.105px",
            }}
            d="M244.7 388.46h7.78l-2.02 9.29h-7.78l2.02-9.29z"
          />
        </g>
        <path
          d="M235.7 303.27s58.3 6.17 57.66 35.91a164.52 164.52 0 0 1-10.62 54.62h-11.56s.59-18.87.2-49.32c-.12-9.13-18.55-12.14-36.56-13.2a41 41 0 0 1-35.24-25.07l-1.23-2.94Z"
          style={{
            fill: "#263238",
            transformOrigin: "245.858px 348.535px",
          }}
          className="animable"
        />
        <path
          d="M285.57 390.7c.06 0-.75 5.47-.75 5.47h-16l-.44-4.88Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "276.977px 393.435px",
          }}
          className="animable"
        />
        <path
          d="M223.22 303.27s42.26 14 43.33 31.36c2 31.94-13.71 59.17-13.71 59.17h-11.67s4.43-13.5 6-42.44c2-36.35-65.83-.06-53.12-48.09Z"
          style={{
            fill: "#263238",
            transformOrigin: "229.594px 348.535px",
          }}
          className="animable"
        />
        <path
          d="M256.37 390.7c.06 0-1.47 5.47-1.47 5.47h-16l.29-4.88Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "247.636px 393.435px",
          }}
          className="animable"
        />
        <path
          d="M253.7 333.89h-65a7.42 7.42 0 0 1 7.42-7.42h50.16a7.42 7.42 0 0 1 7.42 7.42Z"
          style={{
            fill: "#4e658a",
            transformOrigin: "221.2px 330.18px",
          }}
          className="animable"
        />
        <path
          style={{
            fill: "#4e658a",
            transformOrigin: "189.175px 374.96px",
          }}
          className="animable"
          d="m191.71 333.88-9.8 82.16h2.1l12.43-82.16h-4.73z"
        />
        <path
          style={{
            opacity: 0.4,
            transformOrigin: "189.175px 374.96px",
          }}
          className="animable"
          d="m191.71 333.88-9.8 82.16h2.1l12.43-82.16h-4.73z"
        />
        <path
          style={{
            fill: "#4e658a",
            transformOrigin: "207.09px 374.96px",
          }}
          className="animable"
          d="m204.82 333.88-.19 82.16h2.09l2.83-82.16h-4.73z"
        />
        <path
          style={{
            opacity: 0.4,
            transformOrigin: "207.09px 374.96px",
          }}
          className="animable"
          d="m204.82 333.88-.19 82.16h2.09l2.83-82.16h-4.73z"
        />
        <path
          style={{
            fill: "#4e658a",
            transformOrigin: "253.23px 374.96px",
          }}
          className="animable"
          d="m250.69 333.88 9.8 82.16h-2.1l-12.42-82.16h4.72z"
        />
        <path
          style={{
            opacity: 0.4,
            transformOrigin: "253.23px 374.96px",
          }}
          className="animable"
          d="m250.69 333.88 9.8 82.16h-2.1l-12.42-82.16h4.72z"
        />
        <path
          style={{
            fill: "#4e658a",
            transformOrigin: "235.31px 374.96px",
          }}
          className="animable"
          d="m237.58 333.88.19 82.16h-2.09l-2.83-82.16h4.73z"
        />
        <path
          style={{
            opacity: 0.4,
            transformOrigin: "235.31px 374.96px",
          }}
          className="animable"
          d="m237.58 333.88.19 82.16h-2.09l-2.83-82.16h4.73z"
        />
      </g>
    </svg>);
}